import { useContext, useEffect } from 'react';

import { SortOptions } from '@ch/common/types/data';
import { AppContext } from '../../app-context';
import { useQuiz } from './use-quiz';
import { preloadOptionsQuestions } from '../const';
import { preloadDropdownData } from '../helpers/dropdown-options';

export const useDropdownPreloadOptions = () => {
  const { dropdownData, setDropdownData, loadFile } = useContext(AppContext);
  const { userQuestions } = useQuiz();

  useEffect(() => {
    const externalOptionFiles = userQuestions
      .filter(({ identifier }) => preloadOptionsQuestions.includes(identifier))
      .filter(({ file }) => !dropdownData[file])
      .map(q => q.file);

    if (externalOptionFiles.length > 0) {
      preloadDropdownData({
        externalOptionFiles,
        dropdownData,
        callback: setDropdownData,
        sortStrategy: SortOptions.NONE,
      });
    }
  }, [userQuestions, dropdownData, setDropdownData, loadFile]);
};
